import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placement-details',
  templateUrl: './placement-details.component.html',
  styleUrls: ['./placement-details.component.scss']
})
export class PlacementDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
